export default __webpack_public_path__ + "static/media/2D - 3D Animation_icon.ae1d24a7.svg";